// src/components/admin/payroll/PayrollSummary.js
import React from 'react';
import { DollarSign, Users, TrendingUp, CreditCard } from 'lucide-react';

const PayrollSummary = ({ summary = {} }) => {
    const stats = [
        {
            label: 'Total Payroll',
            value: `$${summary.totalPayroll?.toLocaleString() || 0}`,
            icon: DollarSign,
            color: 'bg-blue-500'
        },
        {
            label: 'Employees Paid',
            value: summary.employeesPaid || 0,
            icon: Users,
            color: 'bg-green-500'
        },
        {
            label: 'Total Deductions',
            value: `$${summary.totalDeductions?.toLocaleString() || 0}`,
            icon: CreditCard,
            color: 'bg-red-500'
        },
        {
            label: 'Net Payout',
            value: `$${summary.netPayout?.toLocaleString() || 0}`,
            icon: TrendingUp,
            color: 'bg-purple-500'
        }
    ];

    return (
        <div className="grid grid-cols-1 md:grid-cols-4 gap-6">
            {stats.map((stat, index) => {
                const Icon = stat.icon;
                return (
                    <div key={index} className="bg-white rounded-lg shadow p-6">
                        <div className="flex items-center justify-between">
                            <div>
                                <p className="text-sm text-gray-500">{stat.label}</p>
                                <p className="text-2xl font-bold mt-1">{stat.value}</p>
                            </div>
                            <div className={`${stat.color} p-3 rounded-lg text-white`}>
                                <Icon className="w-6 h-6" />
                            </div>
                        </div>
                    </div>
                );
            })}
        </div>
    );
};

export default PayrollSummary;